module.exports = __webpack_public_path__ + "img/Light Pink.9dd0a83b.svg";